import React from 'react';

import styles from './ideaMiniCardStyles';

import Link from 'buyside/components/presentation/Link/link';
import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';
import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';

import { ideaUrl } from 'buyside/util/urlHelper';
import separateWithDots from 'buyside/util/separateWithDots';

const IdeaMiniCard = ({ idea }) => {
  if (!idea) return null;
  const { id, positions, totalReturn } = idea;
  const isRedacted = positions[0].primarySymbol === 'Redacted';

  return (
    <>
      {isRedacted ? (
        <div className={styles.ideaMiniCard}>
          <RedactedDataPoint Wrapper="div" overlayLeft="5px" blurLeft="5px" />
          <ReturnValue value={totalReturn} />
        </div>
      ) : (
        <Link to={ideaUrl(id)}>
          <div className={styles.ideaMiniCard}>
            <div className={styles.assetSymbol}>
              {separateWithDots(positions.map(position => position.primarySymbol))}
            </div>
            <ReturnValue value={totalReturn} />
          </div>
        </Link>
      )}
    </>
  );
};

export default IdeaMiniCard;
